import * as React from 'react';
import * as styles from './styles.css';

export function MVKWrapper({ children }: React.PropsWithChildren<{}>) {
  return (
    <div data-nav-tab="map/МВК" id="map" className={styles['container']}>
      {children}
    </div>
  );
}
